import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useMainContext } from "../../../Context";
import { useQuery } from "../../../Hooks";
import { listWeb, nesdata } from "../../../Utils/Apis";
import { prices } from "../../../Utils/contstant";

export const useList = () => {
  const [data, setData] = useState({});
  const [init, setInit] = useState({});
  const [loading, setLoading] = useState(true);
  const [drawer, setDrawer] = useState(false);
  const [initLoading, setInintLoading] = useState(true);
  const { changeObj, searchParams, createObjFilter, getValue, clear } =
    useQuery({
      filters: [
        { key: "category_parent_id" },

        { key: "category_id" },
        { key: "price" },
        { key: "sort" },
      ],
    });
  const { citySlug } = useParams();
  const {
    handler,
    post,
    state: { search, mainData },
  } = useMainContext();

  const renderPrice = () => {
    let res = {};
    prices.map(pr => {
      if (getValue("price") == pr.key) {
        res = pr.api;
      }
    });
    return res;
  };
  const get = async () => {
    setLoading(true);
    const { data } = await post(listWeb, {
      ...createObjFilter(),
      citySlug,
      ...renderPrice(),
    });
    setData(data);
    setLoading(false);
  };

  const getForPaginate = async (url) => {
    setLoading(true);
    const { data: newAd } = await post(url);
    setLoading(false);
    setData(newAd);
    window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
  }

  useEffect(() => {
    get();
  }, [searchParams, citySlug]);

  return {
    data,
    loading,
    changeObj,
    init,
    search,
    getValue,
    clear,
    drawer,
    setDrawer,
    mainData,
    get,
    getForPaginate
  };
};
